import { render } from "./NoMenu.vue?vue&type=template&id=f3519c58"
import script from "./NoMenu.vue?vue&type=script&lang=js"
export * from "./NoMenu.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__